import React, { useRef, useMemo, useState, useEffect } from "react";
import { CheckPicker, Form } from "rsuite";

import { debounce } from "utils";
import { buildDateFilterFormValue, normalizeDateRange } from "components/Payments";
import { FlexGrid, FlexGridItem } from "components/base/FlexGrid";
import FieldDataRange from "components/Form/FieldDataRange";
import CustomField from "components/Form/CustomField";


const buildFormValue = (filters) => ({
    ...buildDateFilterFormValue(filters),
    account_id_list: Array.isArray(filters?.account_id_list) ? filters.account_id_list : [],
});


export default ({ filters, onChangeFilters, accounts = [] }) => {
    const [changedFormValue, changeFormData] = useState(() => buildFormValue(filters));
    const onChangeFiltersRef = useRef(onChangeFilters);

    const debouncedOnChangeFilters = useMemo(() => debounce((value) => {
        onChangeFiltersRef.current(value);
    }, 400), []);

    useEffect(() => {
        onChangeFiltersRef.current = onChangeFilters;
    }, [onChangeFilters]);

    useEffect(() => {
        changeFormData(buildFormValue(filters));
    }, [filters]);

    useEffect(() => {
        return () => {
            debouncedOnChangeFilters.cancel();
        };
    }, [debouncedOnChangeFilters]);

    const filteredAccounts = accounts.filter(item => {
        return item.is_managed;
    });

    const formattedAccounts = filteredAccounts.map((account) => {
        return {
            ...account,
            name: `${account.name} / ${account.service}`
        };
    });

    const handleChange = (value) => {
        const nextValue = {
            ...value,
            account_id_list: Array.isArray(value?.account_id_list) ? value.account_id_list : [],
        };
        const normalized = normalizeDateRange(nextValue?.start_end_date);

        let formData = nextValue;

        if (!normalized) {
            changeFormData(formData);
            debouncedOnChangeFilters(formData);
            return;
        }

        const [startDate, endDate] = normalized;
        formData = {
            ...nextValue,
            start_end_date: [startDate, endDate],
            start_date: startDate,
            end_date: endDate,
        };

        changeFormData(formData);
        debouncedOnChangeFilters(formData);
    };


    return (
        <Form formValue={changedFormValue} onChange={handleChange}>
            <FlexGrid align="middle">
                <FlexGridItem>
                    <CustomField
                        accepter={CheckPicker}
                        sticky
                        name="account_id_list"
                        data={formattedAccounts}
                        valueKey="id"
                        labelKey="name"
                        placeholder="Accounts"
                        style={{ width: 290 }}
                        menuStyle={{ width: 360 }}
                        virtualized
                    />
                </FlexGridItem>
                <FlexGridItem>Date from</FlexGridItem>
                <FlexGridItem>
                    <FieldDataRange name="start_end_date" />
                </FlexGridItem>
            </FlexGrid>
        </Form>
    );
};
